/**
 * Json Importer — unified area combining import and history tabs.
 */

import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CommonHeader } from '../../shell/common-header';
import { BulkImport } from './bulk-import';
import { BulkImportHistory } from './bulk-import-history';
import bulk from './bulk-import.module.css';

type Tab = 'import' | 'history';

interface Props {
  onBack: () => void;
  initialTab?: Tab;
}

export function JsonImporter({ onBack, initialTab = 'import' }: Props) {
  const { t } = useTranslation();
  const [tab, setTab] = useState<Tab>(initialTab);
  const [focusJobId, setFocusJobId] = useState<string | null>(null);

  function openHistory(jobId?: string) {
    setFocusJobId(jobId ?? null);
    setTab('history');
  }

  return (
    <div className="portal-shell portal-container">
      <CommonHeader title={t('admin.jsonImporter.title')} showBackButton onBackClick={onBack} />
      <main className="portal-main">
        <div className={`portal-content ${bulk.bulkImportContainer}`}>
          <div className={bulk.jsonImporterTabs}>
            <button
              type="button"
              className={`${bulk.jsonImporterTab} ${tab === 'import' ? bulk.jsonImporterTabActive : ''}`}
              onClick={() => setTab('import')}
            >
              {t('admin.jsonImporter.tabs.import')}
            </button>
            <button
              type="button"
              className={`${bulk.jsonImporterTab} ${tab === 'history' ? bulk.jsonImporterTabActive : ''}`}
              onClick={() => setTab('history')}
            >
              {t('admin.jsonImporter.tabs.history')}
            </button>
          </div>

          <div className={bulk.jsonImporterPanel}>
            {tab === 'import' ? (
              <BulkImport embedded onOpenHistory={openHistory} />
            ) : (
              <BulkImportHistory embedded focusJobId={focusJobId} onFocusClear={() => setFocusJobId(null)} />
            )}
          </div>
        </div>
      </main>
    </div>
  );
}
